import {
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { IPRApprovalHistoryRecord, IPRInternHistoryVersion, PRApprovalHistoryItem } from 'src/app/models/proofreading-history.model';
import { FlowType } from 'src/app/models/proofreading.model';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { LivecoAPIService } from 'src/app/services/liveco-api.service';
import { LoaderService } from 'src/app/services/loader.service';
import { IVersionSelector, ProofreadingHistoryService } from 'src/app/services/proofreading-history.service';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';


export interface version {
    url: string;
    version: IPRInternHistoryVersion | any | undefined;
    current?: boolean;
}

export interface versionGroup {
    nameGroup: string;
    versions: version[];
    prefix?: string;
}

export interface versionSelected {
    nameGroup: string;
    version: IPRInternHistoryVersion | revision;
    prefix?: string;
}

export interface membersRevision {
    _id: string;
    name: string;
    status: string;
}

export interface revision {
    members: membersRevision[];
    pr_status: string;
    pr_status_date: string;
    view_url: string;
}



@Component({
    selector: 'app-approval-proofreading-compare',
    templateUrl: './approval-proofreading-compare.component.html',
    styleUrls: ['./approval-proofreading-compare.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ApprovalProofreadingCompareComponent extends ViewComponent {

    get url() {
        return this.s_proofreadingHistories.compare.approval.url;
    }

    get RA(): IPRApprovalHistoryRecord | undefined {
        return this.s_proofreadingHistories.compare.approval.version_A.value;
    }
    set RA(value: IPRApprovalHistoryRecord | undefined) {
        this.s_proofreadingHistories.compare.approval.version_A.next(value);
    }

    get RB(): IPRApprovalHistoryRecord | undefined {
        return this.s_proofreadingHistories.compare.approval.version_B.value;
    }
    set RB(value: IPRApprovalHistoryRecord | undefined) {
        this.s_proofreadingHistories.compare.approval.version_B.next(value);
    }

    get approvalHistoryItems() {
        return this.s_proofreadingHistories.projectHistories.map((h) => h.approval).filter((h) => !!h) as PRApprovalHistoryItem[];
    };

    selection: any = {};

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected liveco: LivecoAPIService,
        protected s_proofreading: ProofreadingService,
        protected s_proofreadingHistories: ProofreadingHistoryService,
    ) {
        super(route, router, s_alert, s_loader, s_auth);
        this.subscription.add(this.s_proofreadingHistories.compare.approval.version_A.pipe(debounceTime(200)).subscribe(this.handleCompare.bind(this)));
        this.subscription.add(this.s_proofreadingHistories.compare.approval.version_B.pipe(debounceTime(200)).subscribe(this.handleCompare.bind(this)));
    }

    getKeys(history: { [numRelecture: string]: any; }): any {
        return Object.keys(history);
    }

    async handleCompare(version?: IPRApprovalHistoryRecord) {
        const response = await this.liveco.find({ urlA: this.RA?.file_url, urlB: this.RB?.file_url }, "/proofscope/compare");
        console.log('handleCompare', response);
        this.url.next(response?.result || null);

        // if (!this.RA || !this.RB) {
        //     this.url.next(this.RA?.url || this.RB?.url || null);        
        // } else {
        //     const response = await this.liveco.find$({ urlA: this.RA?.file_url, urlB: this.RB?.file_url }, "/proofscope/compare");
        //     this.url.next(response?.result || null);    
        // }  
    }

    reset(): void {
        this.s_proofreadingHistories.compare.approval.version_A.next(undefined);
        this.s_proofreadingHistories.compare.approval.version_B.next(undefined);
        this.url.next(null);
    }

    selected(document: 'A' | 'B', selection: IVersionSelector | null) {
        switch (document) {
            case 'A':
                this.selection['A'] = selection;
                if (!selection) {
                    this.RA = undefined;
                    return;
                }
                this.RA = this.approvalHistoryItems.find((h) => h.proofreadingID === selection.id)?.history[this.getPrefixRelecture(selection.flow).short + selection.relecture];
                break;
            case 'B':
                this.selection['B'] = selection;
                if (!selection) {
                    this.RB = undefined;
                    return;
                }
                this.RB = this.approvalHistoryItems.find((h) => h.proofreadingID === selection.id)?.history[this.getPrefixRelecture(selection.flow).short + selection.relecture];
                break;
        }
    }

    getPrefixRelecture(flow: FlowType) {
        return ProofreadingService.getPrefixRelecture(flow);
    }
}




